import React from "react"
import { Clients, News } from "@sections"
import { Layout } from "@layout"

const PageNotFound = () => {
  return (
    <div className="not-found-page">
      <Layout light>
        <div className="not-found-page-content">
          <h2>{`A keresett oldal nem található :(`}</h2>
        </div>
        <News />
        <Clients />
      </Layout>
    </div>
  )
}

export default PageNotFound
